import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { UserAccountData } from 'src/reducers/userAccount';
import {
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    withStyles,
    TextField,
    Grid,
    Button,
    Modal,
    Backdrop,
    Fade,
    Container,
    CssBaseline,
    Card,
    CardContent,
    IconButton
} from '@material-ui/core';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import EditIcon from '@material-ui/icons/Edit';
// import RotateLeftOutlinedIcon from '@material-ui/icons/RotateLeftOutlined';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export interface UserAccountPageProps {
    userAccounts: UserAccountData[];

    addAccount: () => void;
    getUserAcc: (username: string) => void;
    editAccount: () => void;
    resetUsers: () => void;
    resetPassword: (username: string) => void;

    addPusername: (pusername: string) => void;
    addNickname: (nickname: string) => void;
    addEmailuser: (emailuser: string) => void;
    addMobileuser: (mobileuser: string) => void;

    pusername: string;
    nickname: string;
    emailuser: string;
    mobileuser: string;
}

// interface TableState {
//     columns: Array<Column<UserAccountData>>;
//     data: UserAccountData[];
// }
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 500,
        },
        centerButton: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            outlineStyle: 'none',
            boxShadow: 'none',
            borderColor: 'transparent',
            '& :focus': {
                outline: 'none'
            }
        },
        card: {
            maxWidth: 550
        },
        form: {
            width: '100%', // Fix IE 11 issue.
        },
        submit: {
            margin: theme.spacing(1, 0, 0)
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        color: {
            '&:hover': {
                backgroundColor: '#23a710e6',
                color: '#fff'
            }
        }
    })
);

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
        },
    },
})(TextField);

export const UserAccountPage: React.StatelessComponent<UserAccountPageProps> = (props) => {
    const classes = useStyles({});

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        props.resetUsers();
        setOpen(true);
    };
    const handleClose = () => {
        props.resetUsers();
        setOpen(false);
    };
    const handleSubmit = () => {
        props.addAccount();
        setOpen(false);
    };

    const [openEdit, setOpenEdit] = React.useState(false);
    const handleOpenEdit = () => {
        setOpenEdit(true);
    };
    const handleCloseEdit = () => {
        props.resetUsers();
        setOpenEdit(false);
    };
    const handleSubmitEdit = () => {
        props.editAccount();
        setOpenEdit(false);
    };

    const [userName, setuserName] = React.useState('');
    const [openPassword, setOpenPassword] = React.useState(false);

    const handleClickPasswordOpen = (username: string) => {
        setuserName(username);
        setOpenPassword(true);
    };

    const handlePasswordClose = () => {
        setuserName('');
        setOpenPassword(false);
    };
    const handlePassword = () => {
        props.resetPassword(userName);
        setuserName('');
        setOpenPassword(false);
    };

    return (
        <div className={classes.root}>
            <Grid container justify="flex-end">
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.color}
                        onClick={handleOpen}
                        startIcon={<AddCircleOutlineRoundedIcon />}
                    >
                        Add New User
                    </Button>
                </Grid>
            </Grid>
            <TableContainer component={Paper}>
                <Table className={classes.table} size="small" stickyHeader aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">User ID</TableCell>
                            <TableCell align="left">Username</TableCell>
                            <TableCell align="left">E-mail</TableCell>
                            <TableCell align="left">Mobile Number</TableCell>
                            <TableCell align="left">Edit</TableCell>
                            {/* <TableCell align="left">Reset Password</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.userAccounts.map((useraccount, index) => (
                            <TableRow hover key={index}>
                                <TableCell>
                                    {useraccount.pusername}
                                </TableCell>
                                <TableCell>
                                    {useraccount.nickname}
                                </TableCell>
                                <TableCell>
                                    {useraccount.email}
                                </TableCell>
                                <TableCell>
                                    {useraccount.mobile}
                                </TableCell>
                                <TableCell>
                                    <IconButton
                                        size="small"
                                        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                                            handleOpenEdit();
                                            props.getUserAcc(event.currentTarget.value as string);
                                        }}
                                        id={JSON.stringify(useraccount)}
                                        value={useraccount.pusername}
                                        color="primary"
                                        aria-label="edit"
                                        className={classes.iconbutton}
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </TableCell>
                                {/* <TableCell>
                                    <IconButton
                                        size="small"
                                        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                                            handleClickPasswordOpen(event.currentTarget.value as string);
                                            // getUserName(event.currentTarget.value as string);
                                        }}
                                        id={JSON.stringify(useraccount)}
                                        value={useraccount.pusername}
                                        color="primary"
                                        aria-label="reset"
                                        className={classes.iconbutton}
                                    >
                                        <RotateLeftOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </TableCell> */}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Dialog
                open={openPassword}
                onClose={handlePasswordClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Password Reset</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are You Sure to Reset your Password ?
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handlePasswordClose} color="secondary">
                        No
                    </Button>
                    <Button onClick={handlePassword} color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <Container component="main" maxWidth="sm">
                        <CssBaseline />
                        <div>
                            <Card className={classes.card}>
                                <CardContent>
                                    <form className={classes.form} noValidate>
                                        <Grid container spacing={2}>
                                            <Grid item xs={4}>
                                                <TextField
                                                    size="small"
                                                    fullWidth
                                                    autoFocus
                                                    label="User ID"
                                                    onChange={event => props.addPusername(event.target.value)}
                                                    value={props.pusername}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <TextField
                                                    size="small"
                                                    fullWidth
                                                    label="Username"
                                                    onChange={event => props.addNickname(event.target.value)}
                                                    value={props.nickname}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Mobile"
                                                    onChange={event => props.addMobileuser(event.target.value)}
                                                    value={props.mobileuser}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="E-mail"
                                                    onChange={event => props.addEmailuser(event.target.value)}
                                                    value={props.emailuser}
                                                />
                                            </Grid>
                                            <Grid item sm={6} className={classes.centerButton}>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    color="primary"
                                                    className={classes.submit}
                                                    onClick={handleSubmit}
                                                >
                                                    Add
                                                </Button>
                                            </Grid>
                                            <Grid item sm={6} className={classes.centerButton}>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    color="secondary"
                                                    className={classes.submit}
                                                    onClick={handleClose}
                                                >
                                                    Cancel
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </CardContent>
                            </Card>
                        </div>
                    </Container>
                </Fade>
            </Modal>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={openEdit}
                onClose={handleCloseEdit}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={openEdit}>
                    <Container component="main" maxWidth="sm">
                        <CssBaseline />
                        <div>
                            <Card className={classes.card}>
                                <CardContent>
                                    <form className={classes.form} noValidate>
                                        <Grid container spacing={2}>
                                            <Grid item xs={4}>
                                                <CssTextField
                                                    size="small"
                                                    fullWidth
                                                    disabled
                                                    label="User ID"
                                                    onChange={event => props.addPusername(event.target.value)}
                                                    value={props.pusername}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <CssTextField
                                                    size="small"
                                                    fullWidth
                                                    label="Username"
                                                    onChange={event => props.addNickname(event.target.value)}
                                                    value={props.nickname}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Mobile"
                                                    onChange={event => props.addMobileuser(event.target.value)}
                                                    value={props.mobileuser}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    autoFocus
                                                    size="small"
                                                    label="E-mail"
                                                    onChange={event => props.addEmailuser(event.target.value)}
                                                    value={props.emailuser}
                                                />
                                            </Grid>
                                            <Grid item sm={4} className={classes.centerButton}>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    color="primary"
                                                    className={classes.submit}
                                                    onClick={() => handleClickPasswordOpen(props.pusername as string)}
                                                >
                                                    Reset Password
                                                </Button>
                                            </Grid>
                                            <Grid item sm={4} className={classes.centerButton}>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    color="primary"
                                                    className={classes.submit}
                                                    onClick={handleSubmitEdit}
                                                >
                                                    Update
                                                </Button>
                                            </Grid>
                                            <Grid item sm={4} className={classes.centerButton}>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    color="secondary"
                                                    className={classes.submit}
                                                    onClick={handleCloseEdit}
                                                >
                                                    Cancel
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </CardContent>
                            </Card>
                        </div>
                    </Container>
                </Fade>
            </Modal>
        </div >
    );
};

export default UserAccountPage;



// WEBPACK FOOTER //
// ./src/components/layouts/UserAccountView.tsx